<template>
<body class="hold-transition login-page">
       <div class="login-box">
  <div class="login-logo">
    <b>ownaRadio</b>
  </div>
  <!-- /.login-logo -->
      <p class="alert alert-secondary mb-3">A verification code has been sent to your email address.</p>

  <div class="card">
    <div class="card-body login-card-body">
      <h6>Reset Password</h6>

<ValidationObserver ref="observer" v-slot="{invalid, passes }">
      <form @submit.prevent="passes(submit)" >
     <p class="alert alert-danger" v-if="errors.unauthorized">{{ errors.unauthorized[0]}}</p>
    

  <validation-provider name="email" rules="required|email" v-slot="{ errors }">
        <div class="input-group mb-3">
          <input name="email" v-model="form.email" readonly type="text" class="form-control" placeholder="Email">
          <div class="input-group-append">
            <div class="input-group-text">
              <span class="fas fa-envelope"></span>
            </div>
          </div>
        </div>
        <span class="text-danger">{{ errors[0] }}</span>
 </validation-provider>
   <validation-provider name="token" rules="required|numeric|digits:6" v-slot="{ errors }">
        <div class="input-group mb-3">
          <input name="number" v-model="form.token" type="text" class="form-control" placeholder="Token">
          <div class="input-group-append">
            <div class="input-group-text">
              <span class="fas fa-coins"></span>
            </div>
          </div>
        </div>
        <span class="text-danger">{{ errors[0] }}</span>
 </validation-provider>
  <validation-provider name="password" rules="required|min:8" v-slot="{ errors }">
        <div class="input-group mb-3">
          <input name="password" v-model="form.password" type="password" class="form-control" placeholder="Password">
          <div class="input-group-append">
            <div class="input-group-text">
              <span class="fas fa-lock"></span>
            </div>
          </div>
        </div>
        <span class="text-danger">{{ errors[0] }}</span>
  </validation-provider>
  <validation-provider name="password_confirmation" rules="required|confirmed:password" v-slot="{ errors }">
        <div class="input-group mb-3">
          <input name="password_confirmation" v-model="form.password_confirmation" type="password" class="form-control" placeholder="Confirm Password">
          <div class="input-group-append">
            <div class="input-group-text">
              <span class="fas fa-lock"></span>
            </div>
          </div>
        </div>
        <span class="text-danger">{{ errors[0] }}</span>
  </validation-provider>
            <button :disabled="invalid || loading||!onLine" type="submit" 
            class="btn btn-info btn-block btn-flat">
            {{loading?'Loading...':'Create Account'}}
            </button>
      </form>

          <p class="mb-2 mt-2">
        Before proceeding, please check your email for a verification code.
      </p>
       <p class="mb-2">
        If you did not receive the email. refresh the page and reset the password again.
      </p>
    

</ValidationObserver>

    </div>
    <!-- /.login-card-body -->
  </div>
</div>
<!-- /.login-box -->
</body>
</template>

<script type="text/ecmascript-6">

import { mapState } from "vuex";
import { REGISTER } from "@/store/action-types";

import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "Register",
  components: {
    ValidationObserver,
    ValidationProvider
  },

    data() {
        return {
            form : {
            email: '',
            token:'',
            password: '',
            password_confirmation: ''
            }

        }
    },

     computed: mapState({
      errors: (state) => state.errors,
      loading: (state) => state.loading,
      onLine: (state) => state.auth.onLine,
    }),


    methods: {

        submit(){
              this.$store.dispatch('RESET_PASSWORD', this.form ).then( () => {                 
             this.$router.push('/', () => {})
            }).catch( () =>  {
              this.$refs.observer.setErrors(this.errors);
            } )

          },
    },
    
}
</script>
